import { Add } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Fab, IconButton, useTheme, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'GenButton';

const classes = {
  displayFab: `${PREFIX}-display-fab`,
};

const StyledGrid = styled('div')(({ theme }) => ({
  [`& .${classes.displayFab}`]: {
    position: 'fixed',
    bottom: '5%',
    right: '5%',
    boxShadow: 'none',
  },
}));

const GenButton = ({
  size = 'small',
  variant = 'outlined',
  color = 'primary',
  startIcon = null,
  endIcon = null,
  sx = null,
  text = 'button',
  onClick = () => {},
  type = null,
  form = null,
  iconForIconButton = null,
  displayFab = false,
  loading = false,
  fabIcon = <Add />,
  ...props
}) => {
  const theme = useTheme();
  const isSmallSizeBreakPoint = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <StyledGrid>
      {!iconForIconButton ? (
        <>
          {isSmallSizeBreakPoint && displayFab ? (
            <Fab
              color="primary"
              onClick={onClick}
              className={classes.displayFab}
            >
              {fabIcon}
            </Fab>
          ) : (
            <LoadingButton
              size={size}
              variant={variant}
              startIcon={startIcon}
              color={color}
              endIcon={endIcon}
              onClick={onClick}
              sx={sx}
              type={type}
              form={form}
              loading={loading}
              {...props}
            >
              <>{text}</>
            </LoadingButton>
          )}
        </>
      ) : (
        <IconButton
          size={size}
          variant={variant}
          color={color}
          sx={sx}
          onClick={onClick}
          type={type}
          form={form}
          {...props}
        >
          {iconForIconButton}
        </IconButton>
      )}
    </StyledGrid>
  );
};

export default GenButton;
